import React, { useState, useEffect } from "react";
import { GetFullURL } from "../../../CommonComponents/GlobalConfFiles/URLs";
import { useFetch } from "../../../hooks/useFetch";
import { LoadingScreen } from "../../../CommonComponents/LoadingScreen/index";
import Button from "react-bootstrap/Button";
import MessageLog from "../../../CommonComponents/Messages/MessageLog";
import { mainArray } from "./Fields";
import { useNavigate } from "react-router-dom";
import { useMessage } from "../../../hooks/UseMessage";
import { saveAs } from "file-saver";
import ShipDocField from "../../../CommonComponents/EnhancedFields/ShipDoc/ShipDocField";
import ShipDocList from "../../../CommonComponents/DropDowns/ShipDoc/ShipDocList";

export default function ShipDocPDF(props) {
  let navigate = useNavigate();
  const [showPDF, setShowPDF] = useState(false);
  const [_createErrorMessage, _errorMessages, _setErorMessages] = useMessage();
  const [bolPdf, setBolPdf] = useState();
  const [shipDoc, setShipDoc] = useState();
  const [showShipDocList, setShowShipDocList] = useState(false);
  const [shipDocFieldName, setShipDocFieldName] = useState();

  const [_getShipDocList, _shipDocList, , , , , , _loadingShipDocList] =
    useFetch(GetFullURL("ShippingDocList"), { method: "POST" });

  const [
    _shipDocPDF,
    _shipDocPDFData,
    _setShipDocPDFData,
    _errorShipDocPDF,
    _setErrorShipDocPDF,
    _successshipDocPDF,
    _setSuccessShipDocPDF,
    _loadingShipDocPDF,
  ] = useFetch(GetFullURL("ShipDocPDF"), { method: "POST" });

  const operationLoading = _loadingShipDocPDF || _loadingShipDocList;

  function clearMessages(e) {
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        _setSuccessShipDocPDF([]);
        break;
      case "error":
        _setErrorShipDocPDF([]);
        _setErorMessages([]);
        break;
      default:
        break;
    }
  }

  const onChange = (e) => {
    const {
      target: { value, name },
    } = e;
    let newValue;
    switch (e.target.type) {
      case "number":
        newValue = Number(value);
        break;
      default:
        newValue = value;
        break;
    }
    const newValueObject = { [name]: newValue };
    setShipDoc((prevState) => {
      return { ...prevState, ...newValueObject };
    });
  };

  const fieldsState = {
    dropDowns: [],
  };

  const mainFieldsToRender = mainArray(fieldsState);
  var shipDocField = mainFieldsToRender.find(({ id }) => id === "id");

  const mergedFieldData = (field) => {
    let newFieldObject = { ...field, dataSource: shipDoc, onChange };

    return newFieldObject;
  };

  const saveFile = () => {
    saveAs(`data:application/pdf;base64,${bolPdf}`, `BOL-${shipDoc.id}.pdf`);
  };

  useEffect(() => {
    if (bolPdf) {
      setShowPDF(true);
    }
  }, [bolPdf]);

  return (
    <>
      <section className="heroCard heroPartner" style={{ height: "auto" }}>
        <div className="container-fluid">
          {operationLoading && <LoadingScreen />}
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="cardHeader">
                  <h2>BOL PDF</h2>
                </div>
                <div className="cardBody">
                  <ShipDocField
                    field={mergedFieldData(shipDocField)}
                    setShowShipDocList={setShowShipDocList}
                    setShipDocFieldName={setShipDocFieldName}
                    _getShipDocList={_getShipDocList}
                  />
                  <div
                    style={{
                      display: "flex",
                      marginTop: "10px",
                      justifyContent: "space-between",
                    }}
                  >
                    <Button
                      style={{
                        width: "32%",
                      }}
                      onClick={() => {
                        if (shipDoc?.id === null || shipDoc?.id === undefined) {
                          _createErrorMessage("87");
                        } else {
                          _shipDocPDF(
                            {
                              data: {
                                Id: shipDoc.id,
                              },
                            },
                            ({ data }) => {
                              if (data != null) {
                                setBolPdf(data);
                              }
                            }
                          );
                        }
                      }}
                    >
                      Display PDF
                    </Button>
                    {showPDF ? (
                      <Button
                        style={{
                          width: "32%",
                        }}
                        onClick={() => {
                          saveFile();
                        }}
                      >
                        Download PDF
                      </Button>
                    ) : (
                      ""
                    )}

                    <Button
                      onClick={() => {
                        navigate(-1);
                      }}
                      style={{
                        width: "32%",
                        background: "#DA1212",
                        borderColor: "#DA1212",
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 mt-4">
              <MessageLog
                errorMessages={[..._errorShipDocPDF, ..._errorMessages]}
                successMessages={[..._successshipDocPDF]}
                clearMessages={clearMessages}
              ></MessageLog>
            </div>
            {showPDF ? (
              <embed
                src={`data:application/pdf;base64,${bolPdf}`}
                width="100%"
                height="600px"
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <ShipDocList
          _shipDocList={_shipDocList}
          showShipDocList={showShipDocList}
          setShowShipDocList={setShowShipDocList}
          shipDocFieldName={shipDocFieldName}
          onChange={onChange}
        />
      </section>
    </>
  );
}
